<template lang="html">
<div class="h-screen w-screen">
  <section
    v-cloak
    class="TheTimer dark-background"
  	:class="{
      'with-controls'     : controlsAreVisible || keyboardInputIsVisible,
      'is-not-running'    : !isRunning,
      'no-keyboard-input' : !keyboardInputIsVisible
    }"
    ref="main"
  	@click.stop="onClickBackground"
  >
    <KeyboardShortcuts
  		@onSpaceBarPress="handleSpaceBarPress"
  		@onPlusPress="handlePlusPress"
  		@onMinusPress="handleMinusPress"
  		@onrPress="handlerPress"
  		@ontPress="handletPress"
  		@onShiftRPress="handleShiftRPress"
  		@onfPress="handlefPress"
  		@onNumberPress="handleNumberPress"
    />
    <div class="flex justify-center mt-20">
    <!-- <div class="gads border-2 border-red-700"></div> -->
    <!-- 728x90/320x50 -->
    <ins class="adsbygoogle gads"
     style="display:inline-block"
     data-ad-client="ca-pub-9042830031090852"
     data-ad-slot="2243191826"></ins>
    <!-- <div id="waldo-tag-12764"></div> -->
    </div>
    <div
      ref="timeRemainingContainer"
      class="time-remaining-container"
      :class="[
        cssClass,
        {
          'pulse'            : animatePulse,
          'long-pulse'       : animateLongPulse,
          'warning-colors'   : timeIsAlmostUp || isCountingUp,
        }]"
      @animationend="animatePulse = animateLongPulse = false"
    >

    	<div
        class="time-remaining mt-10"
        @click.stop='onTimeRemaining("hours")'
      >
        <span v-show="isCountingUp">+</span>
      	<div class="col-hours" v-show="timeRemaining.hours > 0">
          <span v-text="timeRemaining.hours" @click.stop='onTimeRemaining()'>0</span>
          <transition name="button">
            <span class="timer-label" v-show="controlsAreVisible && !keyboardInputIsVisible">Hours</span>
          </transition>
        </div>
        
        <div v-show="timeRemaining.hours > 0">:</div>
      	<div class="col-minutes">
          <span v-text="minutesShown" @click.stop='onTimeRemaining("minutes")'>0</span>
          <transition name="button">
            <span class="timer-label minute-style" v-show="controlsAreVisible && !keyboardInputIsVisible">Minutes</span>
          </transition>
        </div>
        <div>:</div>
        <div class="col-seconds">
          <span v-text="secondsShown" @click.stop='onTimeRemaining("seconds")'>00</span>
          <transition name="button">
            <span class="timer-label" v-show="controlsAreVisible && !keyboardInputIsVisible">Seconds</span>
          </transition>
        </div>
      </div>
    </div>
    
    <TimerKeyboardInput
  		v-if="keyboardInputIsVisible"
  		:timeRemaining="timeRemaining"
  		:oldDuration="setDuration"
  		@submit="setNewDuration"
  		@apply="applyNewDuration(newDuration)"
  		@close="cancelKeyboardInput"
    />
    <transition name="button">
      <Adjustment
        v-show="!controlsAreVisible || controlsAreVisible && !keyboardInputIsVisible && !isCountingUp"
        @interactionDetected="$emit('interactionDetected', 'long', true)"
        @increaseDuration="increaseDuration"
        @decreaseDuration="decreaseDuration"
      />
    </transition>
    <transition>
    </transition>

    <transition name="button">
      <div class="bottom-adjustx adjustment2 ">
      <div class="controlsx flex flex-col" v-show="controlsAreVisible || !controlsAreVisible || keyboardInputIsVisible">
        <button
          key="start-pause"
    			class="button primary-primary with-labelx hideable start-pause"
    			v-show="buttonStartPauseIsVisible"
    			@click.stop="onStartPause"
    			v-on:touchstart=""
        >
          <span v-text=startPauseButtonLabel>Start</span>
  			</button>

        <button
          key="reset"
    			class="button primary-primary with-labelx hideable reset"
    			v-show="resetButtonIsVisible"
    			@click.stop="onReset"
    			v-on:touchstart=""
        >
          <span>Reset</span>
  			</button>
      </div>
      </div>
    </transition>

    <!-- <transition name="button">
      <div class="bottom-adjust absolute flex justify-center items-start">
      <div class="controls space-x-4" v-show="controlsAreVisible || !controlsAreVisible || keyboardInputIsVisible">
        <button
          key="start-pause"
    			class="button primary-primary with-label hideable start-pause"
    			v-show="buttonStartPauseIsVisible"
    			@click.stop="onStartPause"
    			v-on:touchstart=""
        >
          <span v-text="startPauseButtonLabel">Start</span>
  			</button>

        <button
          key="reset"
    			class="button primary-primary with-label hideable reset"
    			v-show="resetButtonIsVisible"
    			@click.stop="onReset"
    			v-on:touchstart=""
        >
          <span>Reset</span>
  			</button>
      </div>
      </div>
    </transition> -->

            <div class="bottom-adjust">
        <div class="flex flex-grow justify-center">
        <!-- 728x90/320x50 -->
          <!-- <div id="waldo-tag-12798"></div> -->
          <ins class="adsbygoogle gads"
          style="display:inline-block"
          data-ad-client="ca-pub-9042830031090852"
          data-ad-slot="2243191826"></ins>
          <!-- <div style="height:90px; width:728px" class="border-2 border-red-700"></div> -->
        </div>
        </div>

    <transition name="button">
			<ToggleMute
        v-if="toggleMuteIsVisible"
        :applyWarningColors="timeIsAlmostUp || isCountingUp"
        @unmute="onUnmute"
      />
		</transition>
  </section>
  <!-- 728x90/320x50 sticky footer -->
<!-- <div id="waldo-tag-12761"></div> -->
  </div>
</template>

<script>
import { validateDuration } from "./mixins/validateDuration";
import KeyboardShortcuts from "./KeyboardShortcuts";
import ToggleMute from "./ToggleMute";
import Adjustment from "./Adjustment";
import TimerKeyboardInput from "./TimerKeyboardInput";
import VueTitle from "./Vue-title";

export default {
  name: "TheTimer",

  mixins: [validateDuration],

  components: {
    KeyboardShortcuts,
    ToggleMute,
    Adjustment,
    TimerKeyboardInput,
    VueTitle,
  },

  props: {
    browser: {
      type: String,
      required: false,
    },
    handleKeyboard: {
      // Handle keyboard shortcuts?
      type: Boolean,
      required: false,
    },
    settings: {
      type: Object,
      required: true,
    },
    settingRepeat: {
      // Boolean, but is allowed to be undefined
      required: true,
    },
    repeatDelay: {
      // Delay between 0:00 and auto restart
      type: Number,
      required: true,
    },
    controlsAreVisible: {
      type: Boolean,
      required: true,
    },
    visibleTray: {
      // What tray is visible?
      type: String,
      required: false,
    },
    keyboardInputIsVisible: {
      type: Boolean,
      required: true,
    },
    hoveringOnNotification: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      // For basic timer features
      isRunning: false, // Timer running or on pause?
      setDuration: 600, // Timer duration as to be adjusted by user
      newDuration: 600, // For communication between timer an input component
      targetTime: null, // Absolute time in millis when timer should reach 0:00.
      timeRemaining: {
        // Time remaining
        millis: null, // Source of truth
        hours: 0, // Base on millis
        minutes: 0, // Base on millis
        seconds: 0, // Base on millis
      },
      interval: null, // For interval for runTimer
      togglePause: null, // For time out at starting timer

      // Repeat
      repeating: false, // Set to true during delay between 0:00 and restart
      cancelRepeat: false, // User interactions during the delay between 0:00 and restart when repeat is enabled

      // For UI handling
      interactionTimeout: "", // Timer that is set every time a user does something
      adjustingWhileRunning: false, // Adjustment happening while timer is running? Then don't flash seconds and buttons.
      continueRunningTimer: "", // Timer object to unpause timer after adjustments
      blindKeyboardInputTimeout: null, // Timer that is set when number keys are pressed
      clickedOn: "", // For passing on click events to other components.

      noScrolling: window.matchMedia("(min-height: 460px)"), // Gets automatically updated when viewport changes. Make sure to copy changes to App.vue

      // Sounds
      firstTickSecond: 11,
      tickTracker: "", // A tick sound is played at every second starting at 10. Keep track of whether it's been played already.
      isMuted: false, // If web audio is supported, at least html5 audio should be there. Only in case of iOS + web audio, initial muting is necessary.
      audioCtx: "", // For web audio context
      audioURIs: ["./static/audio/Tick", "./static/audio/Gong"], // Extensions will be added by preloader
      audioBuffers: [""],

      // Animation
      animatePulse: false, // Animates .timeRemaining
      animateLongPulse: false, // Animates .timeRemaining

      // Page header
      pageTitleFirstBlock: "", // This variable gets updated to include the time remaining
    };
  },

  head: {
    title: function () {
      return {
        inner: this.pageTitleFirstBlock,
      };
    },
    link: function () {
      return [
        {
          rel: "canonical",
          href: "https://www.bigtimer.net/",
          id: "canonical",
        },
      ];
    },
  },

  mounted() {
  
    setTimeout(() => {
      (adsbygoogle = window.adsbygoogle || []).push({});
    }, 2000);
    this.parseURLQuery();
    this.runTimerDisplay();
    this.initializeSound();
    this.setInitialPageTitle();
  },

  watch: {
      runNeworAd() {
        setTimeout(() => {
          (adsbygoogle = window.adsbygoogle || []).push({})
            // waldo.refreshTag("waldo-tag-12764")
            // waldo.refreshTag("waldo-tag-12798")
            // waldo.refreshTag("waldo-tag-12761")
    }, 1000);
      },
    // When the duration is adjusted, it is saved in local storage, so it show up next time the page is visited
    setDuration() {
      localStorage.setItem("previouslySetDuration", this.setDuration);

      if (
        this.settings.repeat === true &&
        this.setDuration <= this.repeatDelay
      ) {
        this.$emit("update:settingRepeat", false);
        this.$emit("showNotificationRepeatDisabled");
      }
      this.updateURLQuery({
        hours: this.timeRemaining.hours,
        minutes: this.timeRemaining.minutes,
        seconds: this.timeRemaining.seconds,
      });
    },

    isRunning() {
      this.updateURLQuery();
      this.$emit("togglingRunning", this.isRunning);
      this.isRunning === true
        ? localStorage.setItem("targetTime", this.targetTime)
        : localStorage.removeItem("targetTime");
    },

    "settings.repeat": function (newVal, oldVal) {
      if (newVal && this.setDuration <= this.repeatDelay) {
        setTimeout(() => {
          this.$emit("update:settingRepeat", false);
        }, 400);
        this.$emit("showNotificationRepeatDisabled");
      } else if (!newVal) {
        this.cancelRepeat = true;
      }

      if (newVal && this.isCountingUp && this.isRunning) {
        this.resetTimer();
      }

      this.updateURLQuery();
    },

    cancelRepeat(newVal) {
      if (newVal) {
        this.repeating = false;
      }
    },

    "timeRemaining.hours": function () {
      this.showRemainingTimeInPageTitle(); // Update page title when minutes change (which they can without second when adjusting manually)

      // Don't count up beyond 99:00:00
      if (this.isCountingUp && this.timeRemaining.hours > 98) {
        this.isRunning = false;
        this.timeRemaining.hours = 99;
        this.timeRemaining.minutes = 0;
        this.timeRemaining.seconds = 0;
        this.$emit("timerIsIdle");
      }
    },
    "timeRemaining.minutes": function () {
      this.showRemainingTimeInPageTitle(); // Update page title when minutes change (which they can without second when adjusting manually)
    },
    "timeRemaining.seconds": function () {
      this.showRemainingTimeInPageTitle(); // Update page title when seconds change.

      // Play a tick sound every second below 10
      if (
        this.timeRemaining.hours == "00" &&
        this.timeRemaining.minutes == "00" &&
        this.timeRemaining.seconds < this.tickTracker &&
        this.timeRemaining.seconds > 0
      ) {
        if (this.settings.playTimerCountdownSound) {
          this.playSound(0);
        }
        if (!this.settings.reducedMotion) {
          this.animatePulse = true; // Is set to false again by event listener
        }
        this.tickTracker = this.timeRemaining.seconds; // Can't do a simple -1 because manual adjustment would cause many ticks for seconds < 9
      }

      // Timer complete: show alert
      if (
        this.timeRemaining.hours == 0 &&
        this.timeRemaining.minutes == 0 &&
        this.timeRemaining.seconds == 0
      ) {
        // Not based on millis, because those are not updated when the time is being adjusted.
        this.timerComplete();
      }
    },

    timeIsAlmostUp(newVal) {
      this.$emit("timeIsAlmostUp", newVal);
    },
    isCountingUp(newVal) {
      this.$emit("isCountingUp", newVal);
    },
  },

created() {
  setTimeout(() => {
    (adsbygoogle = window.adsbygoogle || []).push({})
            // waldo.refreshTag("waldo-tag-12764")
            // waldo.refreshTag("waldo-tag-12798")
            // waldo.refreshTag("waldo-tag-12761")
    }, 1000);
},

  methods: {
    // Parse URL query parameters
    parseURLQuery() {
      // Get the query's data
      let queryHours = parseInt(this.$route.query.hours, 10);
      let queryMinutes = parseInt(this.$route.query.minutes, 10);
      let querySeconds = parseInt(this.$route.query.seconds, 10);
      const queryTarget = parseInt(this.$route.query.target, 10);
      const queryRepeat = this.$route.query.repeat;
      const queryAutoStart = this.$route.query.go;

      // Check for alternative, shortened query variable names
      const queryH = parseInt(this.$route.query.h, 10);
      const queryM = parseInt(this.$route.query.m, 10);
      const queryS = parseInt(this.$route.query.s, 10);
      if (queryH) queryHours = queryH;
      if (queryM) queryMinutes = queryM;
      if (queryS) querySeconds = queryS;

      // Make sure the variables are numbers that can be validated
      if (!queryHours) queryHours = 0;
      if (!querySeconds) querySeconds = 0;
      if (!queryMinutes) queryMinutes = 0;

      if (querySeconds > 59) {
        queryMinutes = queryMinutes + ((querySeconds / 60) << 0);
        querySeconds = querySeconds % 60;
      }
      if (queryMinutes > 59) {
        queryHours = queryHours + ((queryMinutes / 60) << 0);
        queryMinutes = queryMinutes % 60;
      }
      if (queryHours > 23) queryHours = 24;

      if (
        this.validDuration({
          hours: queryHours,
          minutes: queryMinutes,
          seconds: querySeconds,
        })
      ) {
        this.setDuration = 3600 * queryHours + 60 * queryMinutes + querySeconds;

        if (this.validTarget(queryTarget)) {
          this.targetTime = queryTarget;
          this.isRunning = true;
        } else if (queryAutoStart) {
          this.$emit("update:controlsAreVisible", false);
          this.resetTimer();
          this.isRunning = true;
        } else {
          this.timeRemaining.hours = queryHours;
          this.timeRemaining.minutes = queryMinutes;
          this.timeRemaining.seconds = querySeconds;
        }
        if (queryRepeat === "true") {
          this.$emit("update:settingRepeat", true);
        } else if (queryRepeat === "false") {
          this.$emit("update:settingRepeat", false);
        }

        // Convert short URL parameters into long ones:
        if (queryH || queryM || queryS > 0) {
          this.updateURLQuery({
            hours: queryHours,
            minutes: queryMinutes,
            seconds: querySeconds,
          });
        }
      } else {
        // Try to get duration from localStorage
        this.loadLocalStorage();
      }
    },

    loadLocalStorage() {
      // Check if a duration was set before
      let s = localStorage.getItem("previouslySetDuration");
      if (s) {
        this.setDuration = Number.parseInt(s, 10);
      }

      // If a targetTime was stored, the timer was running when the window was closed and should continue again.
      s = localStorage.getItem("targetTime");
      if (this.validTarget(s)) {
        this.targetTime = Number.parseInt(s, 10);
        this.isRunning = true;
        _paq.push([
          "trackEvent",
          "Timer",
          "Loaded from local storage",
          this.setDuration,
        ]);
      } else {
        this.resetTimer();
      }
    },

    // Basic timer features
    ///////////////////////

    // Regularly call for the remaining time to be updated. The beating heart of the app. Sorta.
    runTimerDisplay() {
      this.interval = setInterval(this.updateTimerDisplay, 50);
    },

    // Calculate the remaining time in milliseconds - this makes it accurate opposed to using setInterval.
    updateTimerDisplay() {
      if (this.isRunning) {
        this.timeRemaining.millis = this.targetTime - Date.now();

        // Turn millis into hours, minutes and seconds
        this.timeRemaining.hours = Math.abs(
          (this.timeRemaining.millis / 1000 / 3600) << 0
        ); //<< is a bitwise shift operator, shifting by 0 and doing nothing.
        this.timeRemaining.minutes = Math.abs(
          (this.timeRemaining.millis / 1000 / 60) % 60 << 0
        ); //<< is a bitwise shift operator, shifting by 0 and doing nothing. Bitwise math can only run on ints, so there is an internal cast to int inherit in that. Functionally, it's identical to Math.floor(ms/1000/60), but much faster.
        this.timeRemaining.seconds = Math.abs(
          (this.timeRemaining.millis / 1000) % 60 << 0
        );
      }

      // If timer completed while script was paused by browser/browser was closed:
      if (this.timeRemaining.millis < 0 && !this.settings.continueBeyondZero)
        this.setTimerToZero();
    },

    // Update the target time after user changes after an adjustment.
    // Not called when setting absolute durations.
    updateSetTime() {
      // Only update the set duration if the current duration is larger than the initially set duration.
      // Decreases are likely just a small adjustments that should not be considered when the reset button is clicked.
      if (
        (!this.isRunning && !this.adjustingWhileRunning) ||
        this.setDuration <
          this.timeRemaining.hours * 3600 +
            this.timeRemaining.minutes * 60 +
            this.timeRemaining.seconds
      ) {
        this.setDuration =
          this.timeRemaining.hours * 3600 +
          this.timeRemaining.minutes * 60 +
          this.timeRemaining.seconds;
      }
      this.targetTime =
        Date.now() +
        this.timeRemaining.hours * 1000 * 60 * 60 +
        this.timeRemaining.minutes * 1000 * 60 +
        this.timeRemaining.seconds * 1000;
    },

    // Make sure the ticks are played at the right second
    updateTickTracker() {
      if (
        this.timeRemaining.hours == 0 &&
        this.timeRemaining.minutes == 0 &&
        this.timeRemaining.seconds < this.firstTickSecond
      ) {
        this.tickTracker = this.timeRemaining.seconds;
      } else {
        this.tickTracker = this.firstTickSecond;
      }
    },

    // At 0:00 the following should happen
    timerComplete() {
      if (this.isRunning || this.adjustingWhileRunning) {
        if (!this.settings.continueBeyondZero || this.settings.repeat)
          this.isRunning = false;
        this.cancelRepeat = false;

        this.notifyUserThatTimeIsUp();

        // If repeat is toggled, restart
        if (this.settings.repeat && this.setDuration > this.repeatDelay)
          this.repeat();
        else if (!this.settings.continueBeyondZero) this.setTimerToZero();

        if (!this.settings.repeat && this.settings.continueBeyondZero)
          this.targetTime -= 1000; // Because of how we calculate remaining minutes and seconds from millis, this adjustment is necessary.

        // Tracking
        _paq.push(["trackEvent", "Timer", "Complete", this.setDuration]);
        if (this.settings.repeat) {
          _paq.push([
            "trackEvent",
            "Timer",
            "Complete",
            "Repeat on",
            this.setDuration,
          ]);
        } else {
          _paq.push([
            "trackEvent",
            "Timer",
            "Complete",
            "Repeat off",
            this.setDuration,
          ]);
        }
      }
    },

    repeat() {
      this.repeating = true;

      // Reset the timer after a delay
      setTimeout(() => {
        if (!this.cancelRepeat && this.settings.repeat) {
          const duration = this.setDuration - this.repeatDelay;
          this.timeRemaining.hours = (duration / 3600) << 0;
          this.timeRemaining.minutes = duration % 60 << 0;
          this.timeRemaining.seconds = duration % 60 << 0;
        }
        // After even more delay, restart the timer
        setTimeout(() => {
          if (!this.cancelRepeat && this.settings.repeat) {
            this.resetTimer(this.setDuration - this.repeatDelay);
            this.repeating = false;
            this.isRunning = true;
          }
        }, 1000);
      }, this.repeatDelay * 1000);
    },

    notifyUserThatTimeIsUp() {
      // Show animation
      if (!this.settings.reducedMotion) {
        this.$bus.$emit("TheTimer-BackgroundTimerComplete");
      }

      // Play gong
      if (this.settings.playTimerCompleteSound) {
        this.playSound(1);
      }
      if (!this.settings.reducedMotion) {
        this.animateLongPulse = true;
      }

      // Show notification if tab is not active
      if (
        this.settings.showNotifications === true &&
        this.browserTabIsVisible() === false &&
        Notification.permission !== "denied"
      ) {
        const notificationContent = "Time's up!";
        var notification = new Notification(notificationContent);
        _paq.push(["trackEvent", "Notification", notificationContent]);
      }
    },

    setTimerToZero() {
      this.timeRemaining.hours = 0;
      this.timeRemaining.minutes = 0;
      this.timeRemaining.seconds = 0;
      this.isRunning = false;
      this.$emit("timerIsIdle");
    },

    showRemainingTimeInPageTitle() {
      // If duration is less than 1 minute
      if (!this.isRunning && this.setDuration < 60) {
        this.pageTitleFirstBlock = this.setDuration + " Second";
      }
      // If duration is less than 1 hour, in whole minutes
      else if (
        !this.isRunning &&
        this.timeRemaining.hours === 0 &&
        this.setDuration % 60 === 0
      ) {
        const setMinutes = (this.setDuration / 60) << 0;
        this.pageTitleFirstBlock = setMinutes + " Minute";
      }
      // If duration is in whole hours
      else if (!this.isRunning && this.setDuration % 3600 === 0) {
        const setHours = (this.setDuration / 3600) << 0;
        this.pageTitleFirstBlock = setHours + " Hour";
      }
      // All other combinations
      else {
        if (this.timeRemaining.hours > 0)
          this.pageTitleFirstBlock =
            this.timeRemaining.hours +
            ":" +
            this.minutesShown +
            ":" +
            this.secondsShown +
            " ";
        else
          this.pageTitleFirstBlock =
            this.timeRemaining.minutes + ":" + this.secondsShown + " ";
      }
      if (this.isCountingUp)
        this.pageTitleFirstBlock = "+" + this.pageTitleFirstBlock;
      else this.pageTitleFirstBlock += " Countdown";
      this.$emit("updateHead");
    },

    // Keyboard handling
    ////////////////////

    handleSpaceBarPress() {
      if (this.handleKeyboard) {
        this.$emit("interactionDetected", "short", false);
        this.toggleRunning();
      }
    },
    handlePlusPress() {
      if (this.handleKeyboard) {
        this.$emit("interactionDetected", "short", false);
        this.increaseDuration();
      }
    },
    handleMinusPress() {
      if (this.handleKeyboard) {
        this.$emit("interactionDetected", "short", false);
        this.decreaseDuration();
      }
    },
    handlerPress() {
      if (this.handleKeyboard) {
        // "handle r press"
        this.$emit("interactionDetected", "short", false);
        this.resetTimer();
      }
    },
    handletPress() {
      if (this.handleKeyboard) {
        // "handle t press"
        this.isRunning = false;
        let target = "minutes";
        if (this.timeRemaining.hours > 0) target = "hours";
        this.showKeyboardInput(target);
        this.$emit("interactionDetected", "short", false);
      }
    },
    handleShiftRPress() {
      if (this.handleKeyboard) {
        // "handle shift+r press"
        this.$emit("interactionDetected", "short", false);
        this.$emit("update:settingRepeat", !this.settings.repeat);
      }
    },
    handlefPress() {
      if (this.handleKeyboard) {
        this.$emit("interactionDetected", "short", false);
        this.$emit("toggleFullscreen");
      }
    },

    // Set the time in minutes when user types a number
    handleNumberPress(e, number) {
      let newMinutes = Number;

      // If previous number was just entered
      if (this.blindKeyboardInputTimeout != null) {
        const previousNumber = this.timeRemaining.minutes
          .toString()
          .split("")
          .pop();
        newMinutes = "" + previousNumber + number; // "" to concatenate

        if (newMinutes > 60) {
          newMinutes = number;
        }
      } else {
        newMinutes = number;
      }
      this.setDuration = newMinutes * 60;
      this.resetTimer();

      clearTimeout(this.blindKeyboardInputTimeout);

      this.blindKeyboardInputTimeout = setTimeout(() => {
        this.blindKeyboardInputTimeout = null;
      }, 2000);
    },

    // Mouse handlers
    /////////////////

    onStartPause() {
      if (this.keyboardInputIsVisible === true) {
        this.applyNewInput();
      }
      this.toggleRunning();
      this.$emit("interactionDetected", "long", true);
    },

    onClickBackground() {
      // Only toggle running if controls are visible (they are after you move the mouse or tap the screen once).
      if (this.controlsAreVisible) this.toggleRunning();
      this.$emit("interactionDetected", "long", true); // This makes the controls visible if they aren't already.
    },

    onTimeRemaining(target) {
      this.cancelRepeat = true;

      if (this.controlsAreVisible) {
        if (this.isRunning) this.toggleRunning();
        else this.showKeyboardInput(target);
      }
      this.$emit("interactionDetected", "long", true);
    },

    showKeyboardInput(target) {
      this.newDuration = this.setDuration;
      this.$emit("update:keyboardInputIsVisible", true);
      this.$emit("update:controlsAreVisible", false);
      this.setKeyboardFocus(target);
    },

    setKeyboardFocus(target) {
      // Hack for iOS: Create a dummy element to set focus to and then move focus to the desired input field
      let dummy = document.createElement("input");
      dummy.id = "dummy";
      dummy.type = "text";
      dummy.style.position = "absolute";
      dummy.style.top = "45vh"; // Try to approximate the position, so the animation iOS creates looks smooth enough.
      dummy.style.left = "50vw";
      dummy.style.width = "100vw";
      dummy.style.height = 0; // hide cursor (font-size: 0 will zoom to quarks level) (iOS)
      dummy.style.fontSize = "16px"; // Avoid iOS zooming in.
      dummy.style.opacity = 0; // make input transparent :]
      document.getElementById("app").appendChild(dummy);
      dummy.focus();

      // Wait a tick so TheTimerKeyboardInput can be mounted and listen to the event
      this.$nextTick(() => {
        if (target === "seconds") this.$bus.$emit("TheTimer-SetFocusOnSeconds");
        else if (target === "minutes")
          this.$bus.$emit("TheTimer-SetFocusOnMinutes");
        else this.$bus.$emit("TheTimer-SetFocusOnHours");
        const elem = document.querySelector("#dummy");
        if (elem) elem.parentNode.removeChild(elem);
      });
    },

    onReset() {
      this.$emit("interactionDetected", "long", true);
      this.resetTimer();
    },
    onUnmute() {
      this.$emit("interactionDetected", "long", true);
      this.unlockAudioContext(this.audioCtx);
    },

    // Timer control
    ////////////////

    // Start the timer with new input
    applyNewInput() {
      this.$emit("update:controlsAreVisible", true);
      this.$emit("update:keyboardInputIsVisible", false);
      this.setDuration = this.newDuration;
      this.resetTimer();
    },

    // Start and stop the timer.
    toggleRunning() {
      if (this.isRunning) {
        this.isRunning = false;
        if (!this.settings.reducedMotion) {
          this.animatePulse = true;
        }
      } else if (this.canStart && !this.isRunning) {
        this.isRunning = true;
        this.pauseTimerWhileAdjusting();

        if (!this.settings.reducedMotion) {
          this.$bus.$emit("TheTimer-BackgroundFlash");
          this.animateLongPulse = true;
        }
      } else if (this.cancelRepeat) {
        this.resetTimer();
      }
      this.cancelRepeat = true;
    },

    // Set the duration to the previous duration
    resetTimer(duration = this.setDuration) {
      this.pauseTimerWhileAdjusting();
      this.timeRemaining.millis = 0; // Will be recalculated when timer is started. After reaching 0:00, millis can be < 0. A reset would be immediately negated by updateTimerDisplay().
      this.timeRemaining.hours = (duration / 3600) << 0;
      this.timeRemaining.minutes = (duration / 60) % 60 << 0;
      this.timeRemaining.seconds = duration % 60 << 0;
      this.tickTracker = this.firstTickSecond;
      this.targetTime =
        Date.now() +
        this.timeRemaining.hours * 1000 * 60 * 60 +
        this.timeRemaining.minutes * 1000 * 60 +
        this.timeRemaining.seconds * 1000;
    },

    increaseDuration() {
      if (this.isCountingUp) {
        if (!this.isRunning) {
          this.resetTimer();
        }
      } else {
        this.pauseTimerWhileAdjusting();
        // Increase up to 1 minute
        if (this.timeRemaining.hours === 0 && this.timeRemaining.minutes < 1) {
          this.timeRemaining.seconds += 5;
          this.timeRemaining.seconds =
            Math.floor(this.timeRemaining.seconds / 5) * 5;
          if (this.timeRemaining.seconds > 59) {
            this.timeRemaining.seconds = 0;
            this.timeRemaining.minutes++;
          }
        }
        // Increase up to 5 minutes
        else if (
          this.timeRemaining.hours === 0 &&
          this.timeRemaining.minutes < 5
        ) {
          if (this.timeRemaining.seconds < 30) this.timeRemaining.seconds = 30;
          else {
            this.timeRemaining.seconds = 0;
            this.timeRemaining.minutes++;
          }
        }
        // Increase up to 15 minutes
        else if (
          this.timeRemaining.hours === 0 &&
          this.timeRemaining.minutes < 15
        ) {
          this.timeRemaining.seconds = 0;
          this.timeRemaining.minutes++;
        }
        // Increase up to 1 hour
        else if (
          this.timeRemaining.hours === 0 &&
          this.timeRemaining.minutes < 60
        ) {
          this.timeRemaining.seconds = 0;
          this.timeRemaining.minutes += 5;
          this.timeRemaining.minutes =
            Math.floor(this.timeRemaining.minutes / 5) * 5;
          if (this.timeRemaining.minutes > 59) {
            this.timeRemaining.hours++;
            this.timeRemaining.minutes = 0;
          }
        }
        // Increase beyond 1 hour
        else if (this.timeRemaining.hours < 24) {
          this.timeRemaining.seconds = 0;
          this.timeRemaining.minutes += 15;
          this.timeRemaining.minutes =
            Math.floor(this.timeRemaining.minutes / 15) * 15;
          if (this.timeRemaining.minutes > 59) {
            this.timeRemaining.minutes = 0;
            this.timeRemaining.hours++;
          }
        } else {
          this.timeRemaining.hours = 24;
          this.timeRemaining.minutes = 0;
          this.timeRemaining.seconds = 0;
        }
        this.updateSetTime();
        this.updateTickTracker();
      }
    },

    decreaseDuration() {
      if (this.isCountingUp) {
        if (!this.isRunning) {
          this.resetTimer();
        }
      } else {
        this.pauseTimerWhileAdjusting();
        // During the last 10 seconds
        if (
          this.timeRemaining.hours === 0 &&
          this.timeRemaining.minutes === 0 &&
          this.timeRemaining.seconds > 0 &&
          this.timeRemaining.seconds < 10
        ) {
          this.timeRemaining.seconds--;
        }
        // During the last 10–59 seconds
        else if (
          this.timeRemaining.hours === 0 &&
          this.timeRemaining.minutes === 0 &&
          this.timeRemaining.seconds > 0 &&
          this.timeRemaining.seconds >= 10
        ) {
          this.timeRemaining.seconds =
            Math.floor((this.timeRemaining.seconds - 5) / 5) * 5;
        }
        // During the last 1–5 minutes
        else if (
          this.timeRemaining.hours === 0 &&
          this.timeRemaining.minutes > 0 &&
          this.timeRemaining.minutes < 5
        ) {
          // When between 1 and 5 minutes, adjust with 30s
          if (this.timeRemaining.seconds > 30) {
            this.timeRemaining.seconds = 30;
          } else if (this.timeRemaining.seconds > 0) {
            this.timeRemaining.seconds = 0;
          } else {
            this.timeRemaining.minutes--;
            this.timeRemaining.seconds = 30;
          }
        }
        // During the last 5-59 minutes
        else if (
          this.timeRemaining.hours === 0 &&
          this.timeRemaining.minutes > 1
        ) {
          this.timeRemaining.seconds = 0;
          this.timeRemaining.minutes--;
        }
        // When more one hour is remaining
        else if (
          this.timeRemaining.hours === 1 &&
          this.timeRemaining.minutes === 0
        ) {
          this.timeRemaining.seconds = 0;
          this.timeRemaining.minutes = 55;
          this.timeRemaining.hours = 0;
        }
        // When more than one hour is remaining
        else if (this.timeRemaining.hours > 0) {
          if (this.timeRemaining.minutes === 0) {
            this.timeRemaining.hours--;
            this.timeRemaining.minutes = 45;
          } else {
            this.timeRemaining.seconds = 0;
            this.timeRemaining.minutes -= 15;
            this.timeRemaining.minutes =
              Math.ceil(this.timeRemaining.minutes / 15) * 15;

            if (this.timeRemaining.minutes < 0) {
              this.timeRemaining.hours--;
              this.timeRemaining.minutes = 0;
            }
          }
        }
        this.updateSetTime();
        this.updateTickTracker();
      }
    },

    // Duration can be set with input fields/keyboard
    setNewDuration(newDuration) {
      this.isRunning = false;
      this.newDuration = newDuration;
    },

    applyNewDuration(newDuration) {
      this.setNewDuration(newDuration);
      this.setDuration = newDuration;
      this.$emit("update:controlsAreVisible", true);
      this.$emit("update:keyboardInputIsVisible", false);
      this.$emit("interactionDetected", "long", true);
      this.resetTimer();
    },

    cancelKeyboardInput() {
      this.$emit("update:controlsAreVisible", true);
      this.$emit("update:keyboardInputIsVisible", false);
      this.$emit("interactionDetected", "long", true);
    },

    // UI Enhancement
    /////////////////

    // It's annoying when the seconds blink when adjusting the time while the timer is running, so we pause it briefly
    pauseTimerWhileAdjusting() {
      clearTimeout(this.continueRunningTimer);
      if (this.isRunning || this.adjustingWhileRunning) {
        this.isRunning = false;
        this.adjustingWhileRunning = true;
        this.continueRunningTimer = setTimeout(() => {
          this.isRunning = true;
          this.adjustingWhileRunning = false;
          this.updateSetTime();
        }, 500);
      }
    },

    updateURLQuery(args) {
      let hours;
      let minutes;
      let seconds;
      if (args) hours = args.hours;
      if (args) minutes = args.minutes;
      if (args) seconds = args.seconds;

      // Arguments are optional, default to setDuration
      if (typeof hours === "undefined") {
        hours = (this.setDuration / 3600) << 0;
      }
      if (typeof minutes === "undefined") {
        minutes = (this.setDuration / 60) % 60 << 0;
      }
      if (typeof seconds === "undefined") {
        seconds = this.setDuration % 60 << 0;
      }
      // Get current route, so we're not navigating away from other routes.
      const currentRouteName = this.$route.name;

      // Collect and set query parameters
      // I want to keep the string short and make it as readable as possible.
      let query = {};
      if (hours > 0) query.hours = hours;
      if (minutes > 0) query.minutes = minutes;
      if (seconds > 0) query.seconds = seconds;
      query.repeat = this.settings.repeat;
      if (this.isRunning) query.target = this.targetTime;

      // Update the URL with the query created above.
      this.$router.push({ name: currentRouteName, query });
    },

    // Sound
    ////////

    // Depending on browser capabilities OGG or MP3 is used
    createSoundURIs() {
      let format = "";
      let oggSupport = new Audio().canPlayType("audio/ogg; codecs=vorbis"); // Create an audio object to test browser support of OGG
      if (oggSupport != "") {
        // OGG playback is supported
        format = "ogg";
      } else {
        format = "mp3";
      }

      // Replace the partial URIs with the one with the file extension
      this.audioURIs.forEach(function (item, index, thisArray) {
        let URI = item + "." + format;
        thisArray[index] = URI;
      });
    },

    preLoadSounds() {
      this.createSoundURIs();

      if (this.audioCtx) {
        // web audio is supported
        // Create sound buffers
        this.audioURIs.forEach((item, index) => {
          window
            .fetch(item)
            .then((response) => response.arrayBuffer())
            .then((arrayBuffer) =>
              this.audioCtx.decodeAudioData(
                arrayBuffer,
                (audioBuffer) => {
                  this.audioBuffers[index] = audioBuffer;
                },
                (error) => console.error(error)
              )
            );
        });
      } else {
        // web audio is not supported
        // Creating the sound objects makes the browser download them so they are available in cache.
        this.audioURIs.forEach(function (item) {
          let sound = new Audio(item);
        });
      }
    },

    initializeSound() {
      if ("AudioContext" in window || "webkitAudioContext" in window) {
        const AudioContext = window.AudioContext || window.webkitAudioContext;
        this.audioCtx = new AudioContext();

        // Try to unlock the audio context. Probably doesn't work from here, hence
        this.unlockAudioContext(this.audioCtx);
      }
      this.preLoadSounds();
    },

    // iOS requires the audio context to get unlocked before sound can be played programmatically. This function accepts an audio context.
    // https://stackoverflow.com/a/46839941/1171638 contains a solution in case this error shows up again in Safari: "Unhandled Promise Rejection: NotAllowedError: The request is not allowed by the user agent or the platform in the current context, possibly because the user denied permission."
    unlockAudioContext(c) {
      // create an empty buffer
      let buffer = c.createBuffer(1, 1, 22050);
      let source = c.createBufferSource();
      source.buffer = buffer;
      source.connect(c.destination);

      // play the buffer. noteOn is the older version of start()
      source.start ? source.start(0) : source.noteOn(0);

      // by checking the play state after some time, we know if we're really unlocked
      setTimeout(() => {
        if (
          source.playbackState === source.PLAYING_STATE ||
          source.playbackState === source.FINISHED_STATE
        ) {
          // Hide the unmute button if the context is unlocked.
          this.isMuted = false;
        } else {
          this.isMuted = true;
        }
      }, 500); // It's okay to wait that long, because by default isMuted = false

      if (this.browser === "Safari") {
        this.unlockHTMLAudio();
      }
    },

    // Unlock HTML5 Audio - load a data url of short silence and play it
    // This allowws web audio when the mute toggle is on
    unlockHTMLAudio() {
      const silenceDataURL =
        "data:audio/mp3;base64,//MkxAAHiAICWABElBeKPL/RANb2w+yiT1g/gTok//lP/W/l3h8QO/OCdCqCW2Cw//MkxAQHkAIWUAhEmAQXWUOFW2dxPu//9mr60ElY5sseQ+xxesmHKtZr7bsqqX2L//MkxAgFwAYiQAhEAC2hq22d3///9FTV6tA36JdgBJoOGgc+7qvqej5Zu7/7uI9l//MkxBQHAAYi8AhEAO193vt9KGOq+6qcT7hhfN5FTInmwk8RkqKImTM55pRQHQSq//MkxBsGkgoIAABHhTACIJLf99nVI///yuW1uBqWfEu7CgNPWGpUadBmZ////4sL//MkxCMHMAH9iABEmAsKioqKigsLCwtVTEFNRTMuOTkuNVVVVVVVVVVVVVVVVVVV//MkxCkECAUYCAAAAFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV";
      let tag = (HTMLAudioElement = document.createElement("audio"));
      tag.controls = false;
      tag.preload = "auto";
      tag.loop = false;
      tag.src = silenceDataURL;

      tag.play(); // This throws an error in Safari but still works.
    },

    // Play a sound either with web audio or html5. i accepts the location in the sounds array variable.
    playSound(i) {
      // Play the sound with web audio
      if (this.audioCtx) {
        let source = this.audioCtx.createBufferSource();
        source.buffer = this.audioBuffers[i];
        source.connect(this.audioCtx.destination);
        source.start();
      } else {
        // Play the sound with html5
        let sound = new Audio(this.audioURIs[i]); // Create new variable so it can play without stopping the previous gong sound.
        sound.play();
      }
    },

    setInitialPageTitle() {
      if (
        this.timeRemaining.hours != 0 ||
        this.timeRemaining.minutes != 0 ||
        this.timeRemaining.seconds != 0
      )
        this.showRemainingTimeInPageTitle();
      else this.pageTitleFirstBlock = "Set a countdown timer";
      this.$emit("updateHead");
    },

    // Return true if browser tab is currently visible/focussed
    browserTabIsVisible() {
      let stateKey,
        eventKey,
        keys = {
          hidden: "visibilitychange",
          webkitHidden: "webkitvisibilitychange",
          mozHidden: "mozvisibilitychange",
          msHidden: "msvisibilitychange",
        };
      for (stateKey in keys) {
        if (stateKey in document) {
          eventKey = keys[stateKey];
          break;
        }
      }
      return !document[stateKey];
    },
  },

  computed: {
    timeRemainingAsText() {},

    // Can timer be started?
    canStart() {
      return !this.isCountingUp &&
        !this.repeating &&
        (this.timeRemaining.hours > 0 ||
          this.timeRemaining.minutes > 0 ||
          this.timeRemaining.seconds) > 0
        ? true
        : false;
    },
    buttonStartPauseIsVisible() {
      return (this.repeating ||
        this.timeRemaining.hours > 0 ||
        this.timeRemaining.minutes > 0 ||
        this.timeRemaining.seconds > 0) &&
        !(this.isCountingUp && !this.isRunning)
        ? true
        : false;
    },
    toggleMuteIsVisible() {
      return (
        this.isMuted &&
        this.controlsAreVisible &&
        (this.settings.playTimerCountdownSound ||
          this.settings.playTimerCompleteSound)
      );
    },
    startPauseButtonLabel() {
      if (this.isCountingUp && this.isRunning) return "Stop";
      else if (this.isRunning || this.adjustingWhileRunning || this.repeating)
        return "Pause";
      return "Start";
    },
    // Format minutes and seconds to always be 2 digits
    // This can't be done with a simple filter, because that is not supported by v-text.
    minutesShown() {
      if (this.timeRemaining.hours > 0 && this.timeRemaining.minutes < 10) {
        return "0" + parseInt(this.timeRemaining.minutes, 10);
      }
      return this.timeRemaining.minutes;
    },
    secondsShown() {
      if (this.timeRemaining.seconds < 10) {
        return "0" + parseInt(this.timeRemaining.seconds, 10);
      }
      return this.timeRemaining.seconds;
    },
    resetButtonIsVisible() {
      if (
        !this.isRunning &&
        !this.adjustingWhileRunning &&
        !this.keyboardInputIsVisible &&
        !this.repeating &&
        this.setDuration !=
          this.timeRemaining.hours * 3600 +
            this.timeRemaining.minutes * 60 +
            this.timeRemaining.seconds
      ) {
        return true;
      } else {
        return false;
      }
    },

    // Apply different styling during the last part of the duration
    timeIsAlmostUp() {
      // The conditions include timeRemaining.minutes and timeRemaining.seconds instead of
      // timeRemaining.millis to make sure its evaluated correctly while users adjust the timer.
      if (
        this.settings.warnWhenTimeIsAlmostUp &&
        (this.timeRemaining.hours > 0 ||
          this.timeRemaining.minutes > 0 ||
          this.timeRemaining.seconds > 0) &&
        this.timeRemaining.hours * 3600 +
          this.timeRemaining.minutes * 60 +
          this.timeRemaining.seconds <=
          this.lastPart
      )
        return true;
      else return false;
    },

    lastPart() {
      let lastPart = Math.round(this.setDuration / 60 / 5) * 60; // Consider making the 5 a user-defined number.
      if (lastPart > 600) lastPart = 600; // Max. 10 minutes
      return lastPart;
    },

    isCountingUp() {
      return (
        this.timeRemaining.millis < 0 &&
        this.timeRemaining.hours +
          this.timeRemaining.minutes +
          this.timeRemaining.seconds >
          0
      );
    },

    cssClass() {
      if (
        this.isCountingUp &&
        this.timeRemaining.hours < 1 &&
        this.timeRemaining.minutes < 10
      )
        return "has-5-characters";
      else if (
        this.isCountingUp &&
        this.timeRemaining.hours < 1 &&
        this.timeRemaining.minutes > 9
      )
        return "has-6-characters";
      else if (
        this.isCountingUp &&
        this.timeRemaining.hours > 0 &&
        this.timeRemaining.hours < 10
      )
        return "has-8-characters";
      else if (this.isCountingUp && this.timeRemaining.hours > 9)
        return "has-9-characters";
      else if (
        !this.isCountingUp &&
        this.timeRemaining.hours < 1 &&
        this.timeRemaining.minutes > 9
      )
        return "has-5-characters";
      else if (
        !this.isCountingUp &&
        this.timeRemaining.hours > 0 &&
        this.timeRemaining.hours < 10
      )
        return "has-7-characters";
      else if (!this.isCountingUp && this.timeRemaining.hours > 9)
        return "has-8-characters";
      else return null;
    },
  },
};
</script>

<style lang="scss">
// Not scoped so it can applies to children.

@import "../style/abstracts/variables.scss";
@import "../style/abstracts/functions.scss";
@import "../style/abstracts/mixins.scss";

.TheTimer {
  position: relative;
  width: 100vw;
  height: 100vh;
  min-height: calc(var(--vh, 1vh) * 100);
  overflow: hidden;
  cursor: none;

  // Special states and effects
  &.with-controls {
    cursor: default;
  }

@media only screen and (max-width: 768px) {
  .time-remaining-container {
    position: absolute;
    top: 0; 
    bottom: 0;
  }
}

@media all and (display-mode: fullscreen) {
  .time-remaining-container {
    position: absolute;
    top: 0; 
    bottom: 0;
  }
}

  .time-remaining-container {
    // position: absolute;
    // top: 0; 
    // padding-top: 0.0425em; // Center the numbers
    // bottom: 0;
    width: 100vw;
    display: flex;
    align-items: center;
    justify-content: center;

    // min-height: 38px; // This ensures a minimum text size
    padding-bottom: 0.01em; // Baseline shift to avoid numbers getting cut off at bottom

    text-align: center;

    font-family: "BigTimer", "Jost*", "Lato", sans-serif;
    font-size: 82px; // Old 88 to adjust ad
    font-size: unquote("max(88px, 80vh)");

    .firefox & {
      font-size: clamp(
        88px,
        80vh,
        1000px
      ); // Because of Firefox bug: https://bugzilla.mozilla.org/show_bug.cgi?id=1188579
    }

    line-height: 1;

    @media (#{$break-timer-narrow}) {
      font-size: 29vw;

      .firefox & {
        font-size: unquote(
          "min(31vw, 1000px)"
        ); // Because of Firefox bug: https://bugzilla.mozilla.org/show_bug.cgi?id=1188579
      }
    }
    .chrome & {
      // padding-top: 0.165em; // Chrome puts text higher than the other browsers
    }
    // Edge also puts text higher than the other browsers
    .edge & {
      padding-top: 0.13em;
    }

    color: white;

    user-select: none;
    -webkit-tap-highlight-color: transparent; // Do not grey out buttons on mobile
    tap-highlight-color: transparent; // Do not grey out buttons on mobile
    -webkit-touch-callout: none; // Do not show open in new tab call out
    touch-callout: none; // Do not show open in new tab call out

    // overflow: hidden;

    &.has-5-characters {
      @media (#{$break-timer-narrow}) {
        font-size: 29vw; // Old 31vw to adjust ad
        .firefox & {
          font-size: unquote(
            "min(31vw, 1000px)"
          ); // Because of Firefox bug: https://bugzilla.mozilla.org/show_bug.cgi?id=1188579
        }
      }
    }
    &.has-6-characters {
      @media (#{$break-timer-narrow}) {
        font-size: 26vw;
        .firefox & {
          font-size: unquote(
            "min(28vw, 1000px)"
          ); // Because of Firefox bug: https://bugzilla.mozilla.org/show_bug.cgi?id=1188579
        }
      }
    }
    &.has-7-characters {
      font-size: unquote("max(88px, 70vh)");
      .firefox & {
        font-size: clamp(88px, 70vh, 1000px);
      }
      @media (#{$break-timer-narrow}) {
        font-size: 25vw;
        .firefox & {
          font-size: unquote(
            "min(25vw, 1000px)"
          ); // Because of Firefox bug: https://bugzilla.mozilla.org/show_bug.cgi?id=1188579
        }
      }
    }
    &.has-8-characters {
      font-size: unquote("max(88px, 64vh)");
      .firefox & {
        font-size: clamp(88px, 64vh, 1000px);
      }
      @media (#{$break-timer-narrow}) {
        font-size: 22vw;
        .firefox & {
          font-size: unquote(
            "min(22vw, 1000px)"
          ); // Because of Firefox bug: https://bugzilla.mozilla.org/show_bug.cgi?id=1188579
        }
      }
    }
    &.has-9-characters {
      font-size: unquote("max(88px, 57vh)");
      .firefox & {
        font-size: clamp(88px, 57vh, 1000px);
      }
      @media (#{$break-timer-narrow}) {
        font-size: 19vw;
        .firefox & {
          font-size: unquote(
            "min(19vw, 1000px)"
          ); // Because of Firefox bug: https://bugzilla.mozilla.org/show_bug.cgi?id=1188579
        }
      }
    }

    .with-motion & {
      transition: color $duration-very-short + ms ease-out;
    }
    .with-controls & {
      color: $color-off-white;
    }
    &.warning-colors {
      color: $black;
    }
    &.pulse {
      animation-name: pulse;
      animation-duration: 0.6s;
      animation-timing-function: cubic-bezier(0, 0, 0, 1.02);
    }
    &.long-pulse {
      animation-name: long-pulse;
      animation-duration: 0.6s;
      animation-timing-function: cubic-bezier(0, 0, 0, 1.02);
    }
    .chrome & {
      // Compensate line-height rendering in Chrome
      padding-bottom: 4%;
    }
  }


  @keyframes pulse {
    0% {
      transform: scale(1);
    }
    10% {
      transform: scale(0.95);
    }
  }
  @keyframes long-pulse {
    0% {
      transform: scale(1);
    }
    25% {
      transform: scale(1.2);
    }
    100% {
      transform: scale(1);
    }
  }

  // Light background on hover to indicate that keyboard input can be used
  .time-remaining {
    // margin-top: 34%; // added to adjust ad
    // position: absolute; //added to adjust ad
    display: flex;
    background-color: transparent;
    transition: background-color $duration-very-short + ms ease-in;

    .with-controls.is-not-running.no-keyboard-input &:hover {
      cursor: text;
      background-color: transparentize($color-off-white, 0.92);
      transition: background-color $duration-very-short + ms ease-out;
    }
  }
  .col-hours,
  .col-minutes,
  .col-seconds {
    display: flex;
    flex-direction: column;
  }
  .col-seconds {
    width: 1.12em; // Fix width, so the numbers don't dance around with every changing second.
  }
  .timer-label {
    align-self: flex-end;
    height: 0; // So it doesn't affect the positioning of time remaining
    font-size: $font-size-p + rem;
    margin-right: 0.4em;
    user-select: none;
    opacity: 0.9;

    // Make font size relative to timer font size
    @media screen and (min-width: 606px) {
      margin-top: -2em; // At viewport width < 485px, the adjustment buttons would cover the labels with this
      margin-right: 1.45em;
      width: 5em;
      font-size: 0.07em;
      text-align: center;
    }
  }

  // control buttons are transitioned as a group, because the enabling/disabling of them tends to get annoying otherwise. Also there would be an unexpected and superfluous enter transition for the start/pause button when the keyboard input field is hidden.
  .with-motion & {
    .controls,
    .adjustment {
      &.button-enter-active {
        @include enter-active-transitions-for-controls;
      }
      &.button-leave-active {
        @include leave-active-transition-for-controls;
      }
    }

    .controls {
      &.button-enter-to,
      &.button-leave {
        opacity: 1;
        transform: translateY(0);
      }

      &.button-enter,
      &.button-leave-to {
        opacity: 0;
        transform: translateY($medium + rem);
      }
    }
    .adjustment {
      &.button-enter-to,
      &.button-leave {
        opacity: 1;
        transform: translateX(0);
      }
      &.button-enter,
      &.button-leave-to {
        opacity: 0;
        transform: translateX($medium + rem);
      }
    }
  }

  // Container for the plus and minus buttons
  .adjustment {
    // padding-top: 15%;
    top: 0;
    right: $medium + rem;
    position: absolute;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    transform: translateX(
      calc(-1 * env(safe-area-inset-right))
    ); // Wrap around notch

    @include break-padding-1-h {
      right: $default + rem;
    }
  }

  .adjustment2 {
    // padding-top: 15%;
    top: 0;
    left: $medium + rem;
    position: absolute;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    transform: translateX(
      calc(-1 * env(safe-area-inset-right))
    ); // Wrap around notch

    @include break-padding-1-h {
      left: $default + rem;
    }
  }

  // Container for the start and reset buttons
  .controls {
    position: absolute;
    // bottom: $medium + rem;
    left: 0;
    width: 100vw;
    display: flex;
    // flex-direction: row;
    justify-content: center;
    // align-items: center;
    // pointer-events: none;
    

    @media screen and (min-height: $break-xs) {
      height: $small + 2 * $large + rem;
    }
    @include break-padding-1-v {
      // height: $medium + 2 * $large + rem;
      // bottom: $default + rem;
    }
    @media screen and (min-height: 520+px) and (max-aspect-ratio: 1/1) {
      // bottom: 20vh;
      // bottom: calc(25vh - #{($medium + 2 * $large) / 2+rem});
    }
  }
  .plus,
  .start-pause {
    margin-bottom: $small + rem;

    @include break-padding-1-v {
      margin-bottom: $medium + rem;
    }
  }
  .start-pause,
  .reset {
    // width: $button-min-width;
    width: 8rem;
    min-width: 8rem;
    // padding-right: 2.4rem;
    // padding-left: 2.4rem;
    font-family: 'Jost*', 'Lato', sans-serif;
    font-weight: 600;
    font-size: 1.8rem;
  }
}
.top-ad-style {
  top: 8%;
  width: 730px;
  height: 92px;
  }

  .bottom-ad-style {
  // top: 10%;
  width: 730px;
  height: 92px;
  bottom: 105%;
  }

.bottom-adjust {
position: absolute;
bottom: 7%;
right: 0;
left: 0;
}

@media(max-width: 500px) { 
  .bottom-adjust {
  bottom: 11%;
  }
}

.gads { width: 728px; height: 90px; }
@media(min-width: 500px) { .gads { width: 320px; height: 50px; } }
@media(min-width: 800px) { .gads { width: 728px; height: 90px; } }

</style>



// WEBPACK FOOTER //
// src/components/TheTimer.vue